export default function formatCurrency(num) {
  const parts = (num ?? '').toString()
    .split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.join('.');
};

export function toThousands(num) {
  if (num < 1000) {
    return num
  } else {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
}

export function formatSummaries(params) {
  const { columns, data } = params
  const sums = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '總計'
      return
    }
    const values = data.map((item) => Number(item[column.property]))
    if (!values.every((value) => Number.isNaN(value))) {
      let price = toThousands(values.reduce((prev, curr) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
      if (typeof price === 'number' && price.toString().length > 5) {
        price = price.toFixed(2)
      }
      sums[index] = `$${price}`
    } else {
      sums[index] = 'N/A'
    }
    if (column.property === 'avgOrderCount' && data[0]) {
      sums[index] = data[0].forShowAvgOrderCount
    }
    if (column.property === 'ordersCount') {
      sums[index] = sums[index].substring(1);
    }
  })

  return sums
}